import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import get from 'lodash/get';
import MessageView from 'modules/videos/components/view/MessageView';
import React, { useEffect, useMemo, useState } from 'react';
import ReactPlayer from 'react-player/lazy';
import { useSelector } from 'react-redux';
import {
  addCount,
  getVideoPages,
  saveVideoPage,
} from 'services/videoPages.service';
import MetaTags from '../components/MetaTags';

const VideoMessage = ({
  match: {
    params: { id },
  },
}) => {
  const [playing, setPlaying] = useState(false);
  const message = useSelector((s) => s.videos.data[id]);

  useEffect(() => {
    addCount(id, 'visits');
  }, []);

  const videoUrl = useMemo(() => {
    if (message) {
      const { video_url, video_source } = message;
      if (video_source === 'url' || video_source === 'upload') {
        return video_url;
      } else {
        return video_url.replace('webm', 'mp4');
      }
    }
  }, [message]);

  function onStart() {
    if (!playing) {
      setPlaying(true);
      addCount(id, 'plays');
    }
  }

  function onCTAClick() {
    addCount(id, 'clicks');
  }

  if (!message) {
    return (
      <Box>
        <Alert severity="error">Page not found.</Alert>
      </Box>
    );
  }

  const onEmojiReaction = (emoji) => {
    saveVideoPage({
      counter: emoji.value,
      change: '1',
      hash: message.hash,
    });
  };

  const subtitle = get(message, 'media.0.media_entities', []).map((s, idx) => ({
    kind: 'subtitles',
    src: s.file.subtitle_file_url,
    srcLang: s.entity_srclang,
    default: idx === 0,
    mode: 'showing',
  }));

  return (
    <Box>
      <MetaTags data={message} />
      <MessageView
        containerStyle={{ minHeight: '100vh', overflow: 'hidden' }}
        isPreview={false}
        onReaction={onEmojiReaction}
        onCTAClick={onCTAClick}
        message={message}
        renderVideo={
          videoUrl
            ? () => (
                <ReactPlayer
                  controls
                  playing
                  onPlay={onStart}
                  width="100%"
                  height="100%"
                  className="embed-responsive embed-responsive-16by9 video-container"
                  url={videoUrl}
                  config={{
                    file: {
                      attributes: {
                        poster: message.thumbnail_url,
                        crossOrigin: 'anonymous',
                      },
                      tracks: subtitle,
                    },
                  }}
                />
              )
            : undefined
        }
      />
    </Box>
  );
};

export default VideoMessage;
